import { useEffect, useRef, useState } from 'react';

import type React from 'react';

import { emptyObj, fieldError, setClass } from '../../helpers/utils';
import './styles.scss';

type SelectOption = Record<string, unknown>;

type SelectProps = {
	className?: string;
	id?: string;
	name?: string;
	options?: SelectOption[];
	optId?: string;
	optText?: string;
	selected?: string | number;
	placeholder?: string;
	firstOption?: SelectOption;
	onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
	disabled?: boolean;
	size?: string;
	hookForm?: any;
};

export const Select = ({
	className = '',
	id,
	name,
	options,
	optId,
	optText,
	selected,
	placeholder,
	firstOption = {},
	onChange,
	disabled = false,
	size = 'medium',
	hookForm = { formState: { errors: {} } } as any,
}: SelectProps) => {
	const [obj] = useState(Object.keys(firstOption));
	const selectEl = useRef(null);
	const typeSize = {
		medium: 'is-medium',
	};

	const {
		register,
		setValue,
		formState: { errors },
	} = hookForm;

	const isSize = typeSize[size] || '';

	const handleChange = (e) => {
		if (typeof onChange === 'function') {
			onChange(e);
		}
	};

	const setDefaultValue = () => {
		if (selected) {
			setValue(name, selected);
		}
	};

	const setFirstOption = () => {
		if (options.length > 0 && obj.length === 0) {
			setValue(name, optId ? options[0][optId] : options[0].value);
		}
	};

	useEffect(() => {
		setFirstOption();
		setDefaultValue();
	}, [options]);

	return (
		<div
			ref={selectEl}
			className={setClass(`select is-selected
        ${isSize}
        ${disabled ? 'is-disabled' : ''}
        ${fieldError(errors, name) ? 'is-error' : ''}
        ${className}`)}
		>
			<div className="select__control">
				<label htmlFor={id}>{placeholder}</label>
				<select
					id={id}
					name={name}
					disabled={disabled}
					onChange={handleChange}
					{...register?.(name, {
						onChange: (e) => handleChange(e),
					})}
				>
					{obj.length > 0 && !emptyObj(firstOption) && (
						<option value={String(firstOption[obj[0]] ?? '')}>
							{String(firstOption[obj[1]] ?? '')}
						</option>
					)}
					{options.length > 0 &&
						options.map((opt, key) => (
							<option
								key={key}
								value={String((optId ? opt[optId] : opt.value) ?? '')}
							>
								{String((optText ? opt[optText] : opt.option) ?? '')}
							</option>
						))}
				</select>
			</div>
			{fieldError(errors, name) && (
				<span className="message-error">
					{(fieldError(errors, name) as any).message}
				</span>
			)}
		</div>
	);
};
